<template>
  <v-container fluid>
    <v-layout column>
      <v-card>
        <v-btn name="LoadNewUser" v-on:click="NewUserLoad" color="success">Create New User</v-btn>
        <v-flex style="overflow: auto">
          <v-card-title class="title font-weight-heavy">Users
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table name="userListTable" :headers="headers" :items="users" :search="search">
            <template slot="items" slot-scope="props">
              <tr :style="{backgroundColor: (props.item.username === currentUser.username ? '#D3D3D3' : 'transparant' ) }">
               <td>{{ props.item.username }}</td>
               <td>{{ props.item.email }}</td>
               <td>{{ props.item.sms }}</td>
               <td class="justify-center layout px-0">
                <v-icon medium class="mr-2" @click="ChangePasswordLoad(props.item)">vpn_key</v-icon>
                <v-icon medium class="mr-2" @click="clickTableRow(props.item)">edit</v-icon>
                <!-- Checks User to see if are logged in and prevents deletion of account -->
                <v-icon v-if="props.item.username === currentUser.username" medium class="mr-2" color="red">delete_forever</v-icon>
                <v-icon v-else medium class="mr-2" @click="DeleteUser(props.item)">delete</v-icon>
                <div ></div>
               </td>
              </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for
              <strong>"{{ search }}"</strong> found no results.
            </v-alert>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-layout>
    <span>
      <div v-if="UserEditShow ===  true">
        <UserDetails
          :userID = "selectedUser"
          :key="selectedUser"
        />
        </div>
        <div v-else>
          <v-divider></v-divider>
        </div>
        <div v-if="NewUserShow === false">
          <v-divider></v-divider>
        </div>
        <div v-else>
          <NewUser/>
        </div>
        <div v-if="ChangePasswordShow === false">
        <v-divider></v-divider>
        </div>
        <div v-else>
          <ChangePassword
          :userID = "selectedUser"
          :key="selectedUser"
          />
        </div>
      </span>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UserDetails from './UserDetails'
import NewUser from './NewUser'
import ChangePassword from './ChangePassword'
export default {
  props: {
    userID: {
      type: Number,
      default: null
    }
  },
  name: 'UserList',
  components: { UserDetails, NewUser, ChangePassword },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Username', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Contact Number', value: 'sms' },
        { text: 'Actions', value: 'actions' }
      ],
      user: {},
      users: [],
      currentUserIndex: {},
      selectedUser: 0,
      NewUserShow: false,
      ChangePasswordShow: false,
      UserEditShow: false
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {
    ChangePasswordLoad (item) { // hides other cards and shows current
      this.ChangePasswordShow = true
      this.NewUserShow = false
      this.UserEditShow = false
      // eslint-disable-next-line
      // console.log(`Selected user: ${item.username}, ${item.id}`)
      this.selectedUser = item.id
    },
    NewUserLoad () { // hides other cards and shows current
      this.NewUserShow = true
      this.ChangePasswordShow = false
      this.UserEditShow = false
      this.selectedUser = 0
    },
    DeleteUser (item) {
      // alert('The Delete option has not been enabled. Please see system administrator')
      if (confirm('Confirm delete user: ' + item.username + ' !')) {
        this.$http
          .delete('/schemas/users/' + item.id)
          .then(resp => {
            this.getUserListDetails()
          })
          .catch(error => this.deleteUserRequestFailed(error))
      }
    },
    buildUserList (data) {
      this.users = data.users
    },
    deleteUserRequestFailed (error) {
      this.error = 'User can not be deleted'
      // eslint-disable-next-line
      console.log(error)
      this.$emit('error', this.error)
    },
    requestFailed () {
      this.$emit('error', 'Failed to retrieve list of users.')
    },
    clickTableRow (item) { // hides other cards and shows current as well as passes clicked user
      this.NewUserShow = false
      this.ChangePasswordShow = false
      this.UserEditShow = true
      // eslint-disable-next-line
      // console.log(`Selected user: ${item.username}, ${item.id}`)
      this.selectedUser = item.id
    },
    getUserListDetails () {
      var url = `/schemas/users`
      // Get User information
      this.$http
        .get(url)
        .then(response => {
          this.users = response.data.users
          // Scan the list of organisation's -> users
          for (var i = 0; i < this.users.length; i++) {
            if (this.users[i].username === this.currentUser.username) {
              // eslint-disable-next-line
              // console.log(`DEBUG currentUserIndex: ${i}`)
              this.currentUserIndex = i
              break
            }
          }
        })
        .catch(() => this.requestFailed())
    }
  },
  beforeMount () {
    this.getUserListDetails()
  },
  created () {
    // eslint-disable-next-line
    // console.log(`Logged in CurrentUser: ${this.currentUser.username}`)
  }
}
</script>
